import { useState, useEffect, useCallback } from "react";
import DesktopView from "./DesktopView";
import MobileView from "./MobileView";
import { initGA } from "../../analytics/analytics";
import { trackPage } from "../../analytics/tracking";
const MOBILE_BREAKPOINT = 768;

function detectDevice() {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";

  // Desktop browser nhưng đang ở chế độ responsive nhỏ
  if (window.innerWidth < MOBILE_BREAKPOINT) return "android";

  return "desktop";
}

function App() {
  const [device, setDevice] = useState(null);

  const updateDevice = useCallback(() => {
    setDevice(detectDevice());
  }, []);

  useEffect(() => {
    // Khởi tạo GA một lần duy nhất
    initGA();
    
    trackPage('homepage');
    
    updateDevice();

    window.addEventListener("resize", updateDevice);
    return () => window.removeEventListener("resize", updateDevice);
  }, [updateDevice]);

  if (!device) return null;

  if (device === "desktop") return <DesktopView />;

  return <MobileView device={device} />;
}

export default App;